module.exports = __webpack_public_path__ + "img/GQ.06c8f0e1.svg";